import moment from 'moment'
import crypto from 'crypto'
import { useState, useEffect } from 'react'

export function convertToReadableDate(dateString) {
  const data = moment(dateString)
  return data.format('h:mma MM/DD/YY')
}

export function cookieStringToObject() {
  return document.cookie.split(/; */).reduce((obj, str) => {
    if (str === '') return obj
    const eq = str.indexOf('=')
    const key = eq > 0 ? str.slice(0, eq) : str
    let val = eq > 0 ? str.slice(eq + 1) : null
    if (val != null)
      try {
        val = decodeURIComponent(val)
      } catch (ex) {
        /* pass */
      }
    obj[key] = val
    return obj
  }, {})
}

export function useInput(initialValue, onChange) {
  const [value, setValue] = useState(initialValue)

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: event => {
        const newValue = typeof event !== 'object' ? event : event.target.value
        if (typeof onChange === 'function') onChange(newValue)
        setValue(newValue)
      }
    }
  }
}

export function runOnEnter(func) {
  return function runOnEnterHandler(e, ...props) {
    if (e.key === 'Enter') func(e, ...props)
  }
}

export function runOnKey(func, key) {
  return function runOnKeyHandler(e, ...props) {
    if (e.key === key) func(e, ...props)
  }
}

export function debounce(callback, wait) {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => callback(...args), wait)
  }
}

export function useDebounce(func, delay) {
  const [debouncedFunction, setDebouncedFunction] = useState()

  useEffect(() => {
    setDebouncedFunction(() => debounce(func, delay))
  }, [func, delay])

  return debouncedFunction
}

export function constantToReadable(text) {
  return text
    .split('_')
    .filter(a => a)
    .map(word => word[0].toUpperCase() + word.slice(1, word.length).toLowerCase())
    .join(' ')
}

export function camelToReadable(text) {
  return (text.match(/[A-Za-z][a-z]*/g) || []).join(' ').toLowerCase()
}

export function copyToClipboard(str) {
  const el = document.createElement('textarea')
  el.value = str
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

export function toTitleCase(text) {
  return text
    .toLowerCase()
    .split(' ')
    .map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
}

export function statusToStatus(status) {
  const STATUS = {
    UNREAD: 'Unread',
    OPEN: 'Open',
    RESOLVED: 'Resolved',
    CRITICAL: 'Critical',
    GIVENTODR: 'Given To Dr',
    RECEIVEDBACK: 'Received Back',
    LEFTVOICEMAIL: 'Left voicemail',
    URGENTCARE: 'Scheduled with urgent care',
    APPT2WEEKS: 'Appt in 2 weeks',
    APPT4WEEKS: 'Appt in 4 weeks',
    CHECKTASKS: 'Check Tasks',
    SCAN: 'Scan to record/chart',
    FOLLOWUP: 'Follow-up with patient',
    REVIEWED: 'Reviewed',
    GIVENTOCC: 'Given to Care Coordinator'
  }

  if (Object.keys(STATUS).includes(status)) return STATUS[status]
  return 'Unknown'
}

export function hashObject(object) {
  const hash = crypto
    .createHash('md5')
    .update(JSON.stringify(object))
    .digest('hex')
  return hash
}
